import { TextField, Typography } from "@material-ui/core";
import React, { useState, ChangeEvent } from "react";
import { isEmail } from "react-multi-email";
import { t } from "ttag";
import { BaseDialog } from '@coolremote/shared';
import { useStoreActions, useStoreState } from "../../models/RootStore";
import useStyles from "./UserIdentifierChangeRequired.style";

const UserIdentifierChangeRequired = ({ className }: { className?: string }) => {
  const currentUserEmail: string = useStoreState((s) => s.currentUserEmail);
  const isUsernameNotEmail = useStoreState((s) => s.isUsernameNotEmail);
  const checkUsernameAvailability = useStoreActions((actions) => actions.users.checkUsernameAvailability);
  const setIsUsernameNotEmail = useStoreActions((actions) => actions.setIsUsernameNotEmail);
  const updateMe = useStoreActions((action) => action.users.updateMe);

  const [newUserName, setNewUserName] = useState<string>(currentUserEmail || "");
  const [errMessage, setErrMessage] = useState<string | null>(null);

  const classes = useStyles();

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNewUserName(e.target.value);
    setErrMessage(null);
  };

  const onClick = async () => {
    const userNameExist = await checkUsernameAvailability(newUserName);
    if (!userNameExist?.available) {
      setErrMessage(t`E-mail address is already in use by another user.`);
      return;
    }

    updateMe({ username: newUserName })
      .then((re: any) => {
        setIsUsernameNotEmail(false);
      })
      .catch((e: any) => {
        setErrMessage(e.message);
      });
  };

  return (
    <BaseDialog
      className={className}
      open={isUsernameNotEmail}
      onConfirm={onClick}
      confirmLabel={t`Submit`}
      title={t`New Username Policy`}
      hideCancel={true}
      confirmDisabled={!isEmail(newUserName)}
    >
      <p>{t`A new user management policy has been introduced to our Apps, requiring our users to set their user name in a valid email format.`}</p>
      <Typography
        style={{ marginTop: '16px' }}
      >{t`Please enter a valid unique email address to be used as your user name login credentials.`}</Typography>
      <div className={classes.form}>
        <TextField
          variant="outlined"
          placeholder={t`Enter E-mail`}
          label={t`E-mail`}
          fullWidth
          value={newUserName}
          onChange={handleInputChange}
          error={(!!newUserName && !isEmail(newUserName)) || !!errMessage}
          helperText={errMessage}
        />
      </div>
    </BaseDialog>
  );
};

export default UserIdentifierChangeRequired;
